import React from 'react'
import { connect } from 'react-redux'
import { Item, Label } from 'semantic-ui-react'

import {
  ALL,
  STATUS_CANCELED,
  STATUS_INITIATED_BY_USER,
  STATUS_AWAITING_APPROVAL,
  STATUS_APPROVAL,
  STATUS_PAID,
  STATUS_WALK_IN,
  STATUS_ACTIVE,
  STATUS_CHECKED_IN,
  STATUS_IN_MANUAL_REVIEW,
  STALLED,
  STATUS_PRICE_REVIEW,
  STATUS_ACTIVE_NEEDS_RESCHEDULE,
  STATUS_WALK_IN_NEEDS_RESCHEDULE,
  STATUS_INDEFINITE_OPEN,
  STATUS_USER_INITIATED_NEEDS_RESCHEDULE,
  STATUS_WALK_IN_ACTIVE_NEEDS_RESCHEDULE,
  STATUS_WALK_IN_ACTIVE,
  HIGH_TOTAL,
  RECONCILED,
  RESOLVED_RECONCILIATION_FAILURE,
  RECONCILIATION_FAILURE,
  REFUNDED,
  OVER_RETAIL,
  FORBIDDEN_MULTI_SCOPES
} from '../../constants/search_filters'
import SplitClient from "../../utils/splitClient";
import * as sessionHelpers from "../../helpers/sessionHelpers";
import {isDashboardV2} from "../../utils/utils";

class OrderScopeFilters extends React.Component {
  state = { multiSelectMode: false, isDashboardV2: false }

  async componentDidMount() {
    const isV2 = await isDashboardV2()
    this.setState({isDashboardV2: isV2})
  }

  orderScopes() {
    const orderCategoryCounts = this.props.order_category_counts || {}
    const {
      all,
      status_canceled,
      status_initiated_by_user,
      status_awaiting_approval,
      status_approval,
      status_paid,
      status_walk_in,
      status_active,
      status_checked_in,
      status_in_manual_review,
      status_price_review,
      status_active_needs_reschedule,
      status_walk_in_needs_reschedule,
      status_indefinite_open,
      status_user_initiated_needs_reschedule,
      status_walk_in_active_needs_reschedule,
      status_walk_in_active,
      stalled,
      high_total,
      reconciled,
      resolved_reconciliation_failure,
      reconciliation_failure,
      refunded,
      over_retail
    } = orderCategoryCounts

    if (this.props.isReconciliation) {
      return [
        { label: 'All Reconciled', value: RECONCILED, count: reconciled },
        { label: 'Resolved Rec. Failure', value: RESOLVED_RECONCILIATION_FAILURE, count: resolved_reconciliation_failure },
        { label: 'Unresolved Rec. Failure', value: RECONCILIATION_FAILURE, count: reconciliation_failure },
        { label: 'Over Retail', value: OVER_RETAIL, count: over_retail },
        { label: 'Resolved Over Retail', value: REFUNDED, count: refunded }
      ]
    }
    else {
      return [
        { label: 'All Orders', value: ALL, count: all },
        { label: 'User Initiated', value: STATUS_INITIATED_BY_USER, count: status_initiated_by_user },
        { label: 'Walk-in', value: STATUS_WALK_IN, count: status_walk_in },
        { label: 'Active', value: STATUS_ACTIVE, count: status_active },
        { label: 'Awaiting Approval', value: STATUS_AWAITING_APPROVAL, count: status_awaiting_approval },
        { label: 'Approved', value: STATUS_APPROVAL, count: status_approval },
        { label: 'Paid', value: STATUS_PAID, count: status_paid },
        { label: 'Checked-In', value: STATUS_CHECKED_IN, count: status_checked_in },
        { label: 'In Manual Review', value: STATUS_IN_MANUAL_REVIEW, count: status_in_manual_review },
        { label: 'Canceled', value: STATUS_CANCELED, count: status_canceled },
        { label: 'Stalled', value: STALLED, count: stalled },
        { label: 'Price Review', value: STATUS_PRICE_REVIEW, count: status_price_review },
        { label: 'Active Needs Reschedule', value: STATUS_ACTIVE_NEEDS_RESCHEDULE, count: status_active_needs_reschedule },
        { label: 'Walk In Needs Reschedule', value: STATUS_WALK_IN_NEEDS_RESCHEDULE, count: status_walk_in_needs_reschedule },
        { label: 'Indefinite Open', value: STATUS_INDEFINITE_OPEN, count: status_indefinite_open },
        { label: 'User Initiated Needs Reschedule', value: STATUS_USER_INITIATED_NEEDS_RESCHEDULE, count: status_user_initiated_needs_reschedule },
        { label: 'Walk In Active Needs Reschedule', value: STATUS_WALK_IN_ACTIVE_NEEDS_RESCHEDULE, count: status_walk_in_active_needs_reschedule },
        { label: 'Walk In Active', value: STATUS_WALK_IN_ACTIVE, count: status_walk_in_active },
        { label: 'Total Over $500', value: HIGH_TOTAL, count: high_total }
      ]
    }
  }

  updateFilterStore = async (data) => {
    data.current_page = 1;
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: data
    })
    const treatment = await SplitClient.getTreatment("SHOP_ORDERS",{ email: sessionHelpers.getApplicationCookie('current_user_email') })

    if (treatment.SHOP_ORDERS === 'V2' && !this.state.multiSelectMode) {
      this.props.dispatch({
        type: 'SHOP_ORDERS_FILTER_SAGA',
        payload: data
      })
    }
  }

  handleFilter(value) {
    let { order_scopes } = this.props
    const { multiSelectMode } = this.state

    if (multiSelectMode) {
      if (FORBIDDEN_MULTI_SCOPES.includes(value)) return

      if (order_scopes.includes(value)) {
        order_scopes = order_scopes.filter(s => s !== value)
      }
      else {
        order_scopes = order_scopes.concat(value)
      }
    }
    else {
      order_scopes = [value]
    }

    this.updateFilterStore({ order_scopes: order_scopes })
  }

  handleMultiSelectChange = () => {
    const { multiSelectMode } = this.state
    const { order_scopes } = this.props
    this.setState({ multiSelectMode: !multiSelectMode })
    let newScopes = order_scopes.filter(s => !FORBIDDEN_MULTI_SCOPES.includes(s))
    if (multiSelectMode === true)
      newScopes = [order_scopes[0]]
    this.updateFilterStore({ order_scopes: newScopes })
  }

   render() {
    const { multiSelectMode, isDashboardV2 } = this.state
    const { order_scopes } = this.props

    // TODO: move to stylesheet
    const activeStyles = { backgroundColor: '#e3e6ea', fontWeight: 'bold' }

    return (
      <React.Fragment>
        {!isDashboardV2 && <>
          <input
              type="checkbox"
              onChange={this.handleMultiSelectChange}
              checked={multiSelectMode}
              style={{cursor: 'pointer', marginLeft: '15px', marginBottom: '10px'}}
          />
          <small onClick={this.handleMultiSelectChange} style={{cursor: 'pointer', paddingLeft: '5px'}}>
            Multi-select filters
          </small>
        </>
        }

        {
          this.orderScopes().map((scope) => {
            const styles = order_scopes.includes(scope.value) ? activeStyles : {}
            const activeClass= order_scopes.includes(scope.value) ? 'active' : ''
            const cursor = FORBIDDEN_MULTI_SCOPES.includes(scope.value) && multiSelectMode ? 'not-allowed' : 'pointer'
            return (
              <Item
                style={{...styles, cursor: cursor}}
                key={`scope-${scope.value}`}
                className={activeClass}
                onClick={() => this.handleFilter(scope.value)}
              >
                {scope.label}
                <Label className="side-filter-count" color='teal'>{scope.count || 0}</Label>
              </Item>
            )
          })
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  const shopOrders = state.shopOrders || {}
  const filters = state.shopOrderFilters.currentFilters || {}

  return {
    order_category_counts: shopOrders.order_category_counts,
    order_scopes: filters.order_scopes || []
  }
}

export default connect(mapStateToProps)(OrderScopeFilters)
